import {z} from 'zod'

import {RangeSettings} from '../../common/types'
import {TruckForm} from '../../trucks/types'
import {LoadSpacingForm, LoadSpacingScenario} from '../types'

import {ErrorCodes} from './errorCodes'
import {validateFieldRange} from './validateFieldRange'

export const validateTimeOnJobSite = (
  data: LoadSpacingForm & TruckForm,
  scenario: LoadSpacingScenario,
  timeOnJobSiteSettings: RangeSettings,
  ctx: z.RefinementCtx
) => {
  if (!scenario.timeOnJobSite && data.timeOnJobSite) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['timeOnJobSite'],
      message: ErrorCodes.timeOnJobSite.notAllowed + data.isMultipleTruck
    })
  }

  if (scenario.timeOnJobSite) {
    if (!data.timeOnJobSite) {
      ctx.addIssue({
        code: 'custom',
        path: ['timeOnJobSite'],
        message: ErrorCodes.timeOnJobSite.required + data.isMultipleTruck
      })

      return
    }

    validateFieldRange(
      data.timeOnJobSite.time,
      timeOnJobSiteSettings,
      'timeOnJobSite',
      'timeOnJobSite.time',
      ctx
    )
  }
}
